import React from 'react'
import { MapContainer, TileLayer, Popup } from 'react-leaflet'
import { Hero, Columns } from 'react-bulma-components'
import styled from 'styled-components'
import 'leaflet/dist/leaflet.css'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import {
    StyledHeading,
    StyledContainer,
    StyledContent,
    StyledHero,
} from '../../utils/commonStyles'

const CustomStyledHero = styled(StyledHero)`
    min-height: 200px;
    margin-top: 2rem;

    background: linear-gradient(
        to bottom,
        rgba(46, 161, 170, 0) 0%,
        rgba(167, 165, 210, 1)
    );

    .Columns {
        display: flex;
    }

    // Mobile order of columns
    @media (max-width: 768px) {
        .Columns {
            flex-direction: column;
        }

        .sedez {
            order: 1;
        }

        .pisarna {
            order: 2;
        }

        .kontaktProdaja {
            order: 3;
        }

        .kontaktIzvedba {
            order: 4;
        }
    }

    // Desktop order of columns
    @media (min-width: 769px) {
        .Columns {
            flex-direction: row;
            flex-wrap: wrap;
        }

        .sedez {
            flex-basis: 50%;
        }

        .pisarna {
            flex-basis: 50%;
        }

        .kontaktProdaja {
            flex-basis: 50%;
        }

        .kontaktIzvedba {
            flex-basis: 50%;
        }
    }

    .leaflet-container {
        height: 400px;
        width: 100%;
        border-radius: 1rem;
    }

    .leaflet-popup-content-wrapper {
        background-color: #9fdfe9;
    }

    .leaflet-popup-tip {
        background-color: #9fdfe9;
    }

    .leaflet-popup-content p {
        margin: 0;
    }
`

export default function StreetMap() {
    /*https://github.com/masotime/react-leaflet-universal*/
    const { t } = useTranslation()
    return (
        <CustomStyledHero>
            <Hero.Body>
                <StyledContainer>
                    <Columns vCentered>
                        <Columns.Column>
                            <StyledContent>
                                <StyledHeading size={1}>
                                    {t('onas.spaces.title')}
                                </StyledHeading>
                                <p style={{ width: '80%' }}>
                                    {t('onas.spaces.description')}
                                    <br />
                                    <br />
                                </p>

                                <Columns>
                                    <Columns.Column className="sedez">
                                        <StyledContent>
                                            <StyledHeading size={5}>
                                                <b> {t('onas.spaces.seat')}</b>
                                            </StyledHeading>
                                            <p>
                                                Štanjel 5B,
                                                <br />
                                                6222 Štanjel
                                            </p>
                                        </StyledContent>
                                    </Columns.Column>
                                    <Columns.Column className="pisarna">
                                        <StyledContent>
                                            <StyledHeading size={5}>
                                                <b>
                                                    {' '}
                                                    {t('onas.spaces.office')}
                                                </b>
                                            </StyledHeading>
                                            <p>
                                                Center Cvetličarna,
                                                <br />
                                                Vojkova cesta 58
                                                <br />
                                                1000 Ljubljana
                                            </p>
                                        </StyledContent>
                                    </Columns.Column>
                                    <Columns.Column className="kontaktProdaja">
                                        <StyledContent>
                                            <StyledHeading
                                                size={5}
                                                style={{ color: 'white' }}
                                            >
                                                <b> {t('onas.spaces.sales')}</b>
                                            </StyledHeading>
                                            <p>
                                                <a
                                                    href="tel:041 333 267"
                                                    style={{ color: 'white' }}
                                                >
                                                    041 333 267
                                                </a>
                                            </p>
                                        </StyledContent>
                                    </Columns.Column>
                                    <Columns.Column className="kontaktIzvedba">
                                        <StyledContent>
                                            <StyledHeading
                                                size={5}
                                                style={{ color: 'white' }}
                                            >
                                                <b>
                                                    {' '}
                                                    {t('onas.spaces.execution')}
                                                </b>
                                            </StyledHeading>
                                            <p>
                                                <a
                                                    href="tel:041 328 317"
                                                    style={{ color: 'white' }}
                                                >
                                                    041 328 317
                                                </a>
                                            </p>
                                        </StyledContent>
                                    </Columns.Column>
                                </Columns>
                            </StyledContent>
                        </Columns.Column>
                        <Columns.Column style={{ marginTop: '2rem' }}>
                            <MapContainer
                                className="leaflet-container"
                                center={[46.07014, 14.52073]}
                                zoom={17}
                                scrollWheelZoom={false}
                            >
                                <Popup position={[46.07014, 14.52073]}>
                                    <StyledContent>
                                        <p>Kisik d.o.o</p>
                                    </StyledContent>
                                </Popup>
                                <TileLayer
                                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                            </MapContainer>
                        </Columns.Column>
                    </Columns>
                </StyledContainer>
            </Hero.Body>
        </CustomStyledHero>
    )
}
